define(
    'viewmodels/secured/libraries/create/duplicate/select/select',[
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (
        ViewModel,
        dataProvider,
        i19n
        ){

        var vm = new ViewModel(
        {
            id: '',
            i19n: i19n
        });

        vm.activate = function () {
            var self = this;
        };
        vm.attached = function () {
            var self = this;
        };

        return vm;
    }
);
